// @ts-nocheck
"use client" // Error boundaries must be Client Components

import { Button } from "@ui/button"
import mixpanel from "mixpanel-browser"
import { useEffect } from "react"

declare global {
    interface Window {
        newrelic?: {
            noticeError?: (error: Error) => void
        }
    }
}

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    useEffect(() => {
        if (error && typeof window !== "undefined") {
            window.newrelic?.noticeError?.(error)
            mixpanel.track("Error", {
                location: "academy/videos/[slug]",
                message: error.message,
                stack: error.stack,
                digest: error.digest,
            })
        }
        console.error(error)
    }, [error])

    return (
        <div className="mx-auto flex h-full flex-col items-center justify-center space-y-4">
            <h2>Something went wrong!</h2>
            <Button onClick={() => reset()}>Reload</Button>
        </div>
    )
}
